<template>
  <div class="modal fade" role="dialog" id="modalRepuestos" aria-labelledby="modalRepuestos">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close"
                  data-dismiss="modal" aria-label="Cerrar"><span
            aria-hidden="true">&times;</span>
          </button>
          <h4 v-if="moto" class="modal-title uppercase" id="importarModal">
            <i class="fal fa-toolbox"></i> Repuestos | Moto {{ moto.modelo }} | Servicio {{ servicio.nombre }}
          </h4>
        </div>
        <div class="modal-body">
          <button class="btn btn-default btn-sm no-print" style="margin-bottom: 5px"
                  @click.prevent="agregarDetalle()" v-if="!servicio.readonly">
            <i class="fa fa-plus"></i> Agregar
          </button>
          <div class="table-scrollable" v-show="detalles.length > 0">
            <input type="hidden" name="id_detalles_eliminados" v-model="id_detalles_eliminados"/>
            <table class="table table-bordered table-condensed table-striped vmiddle">
              <thead>
              <tr>
                <th style="width: 5%"></th>
                <th style="width: 45%">Repuesto</th>
                <th style="width: 10%" class="text-right">Cantidad</th>
                <th style="width: 20%" class="text-right">
                  Precio Unitario <small class="text-muted">(sin IVA)</small>
                </th>
                <th style="width: 20%" class="text-right">Total <small class="text-muted">(sin IVA)</small></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(detalle, index) in detalles" v-bind:key="index">
                <td class="text-center">
                  <input type="hidden" v-model="detalle.id"/>
                  <button class="btn btn-sm default no-print" style="margin: 0"
                          @click.prevent="eliminarDetalle(index)" v-if="!servicio.readonly">
                    <i class="fa fa-times"></i>
                  </button>
                </td>
                <td class="form-group">
                  <select
                    v-bind:id="`cmbRepuestos-${index}`"
                    v-model="detalle.ag_repuesto_id"
                    class="form-control js-repuestos"
                    :disabled="servicio.readonly">
                    <option :value="detalle.ag_repuesto_id">
                      {{ detalle.sku }} / {{ detalle.nombre }}
                    </option>
                  </select>
                </td>
                <td class="form-group">
                  <input type="number" class="form-control text-right"
                         v-bind:id="`precioUnitario-${index}`"
                         v-model="detalle.cantidad"
                         :disabled="servicio.readonly"
                         @change="calcularTotalDetalle(index)"
                         @keyup="calcularTotalDetalle(index)"/>
                </td>
                <td class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">$</span>
                    <input type="text" class="form-control text-right"
                           v-model="detalle.precio_unitario"
                           @change="calcularTotalDetalle(index)"
                           readonly/>
                  </div>
                </td>
                <td class="form-group">
                  <div class="input-group">
                    <span class="input-group-addon">$</span>
                    <input type="text" class="form-control text-right"
                           v-model="detalle.total" readonly/>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
          <button type="button" class="btn btn-primary"
                  @click.prevent="guardarDetalles()"
                  v-if="!servicio.readonly">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'servicio': {
      required: true,
      type: Object
    },
  },

  data() {
    return {
      moto: null,
      detalles: [],
      repuestos: [],
      id_detalles_eliminados: [],
    }
  },

  methods: {
    eliminarDetalle(index) {
      const detalle = this.detalles[index];
      this.detalles.splice(index, 1);

      if (detalle.id) {
        this.id_detalles_eliminados.push(detalle.id);
      }

      this.$nextTick(() => {
        this.reInitRepuestosSelect2();
      });

      this.calcularTotal();
    },

    agregarDetalle() {
      this.detalles.push({
        'id': null,
        'ag_repuesto_id': null,
        'nombre': null,
        'sku': null,
        'cantidad': null,
        'precio_unitario': null,
        'total': null,
      });

      const index = this.detalles.length - 1;
      this.inicializarComboRepuesto(index);
    },

    guardarDetalles() {
      const indexDetalleInvalido = this.detalles.findIndex((detalle) => {
        // Las filas nuevas que quedaron sin repuesto las descarta el backend, no se validan acá
        if (!detalle.id && !detalle.ag_repuesto_id) {
          return false;
        }

        // v-model entrega la cantidad como texto, así que comparar con 0 nunca daba verdadero
        return !(Number(detalle.cantidad) > 0);
      });

      if (indexDetalleInvalido !== -1) {
        document.getElementById(`precioUnitario-${indexDetalleInvalido}`).focus();
        document.getElementById(`precioUnitario-${indexDetalleInvalido}`).select();
        alert('Ingrese una cantidad mayor a 0.');

        return;
      }

      axios.put('api/agendamiento/repuestos', {
        'detalles': this.detalles,
        'servicio': this.servicio.id,
        'moto': this.moto.id,
        'id_detalles_eliminados': this.id_detalles_eliminados,
      }).then(response => {
        if (response.data && response.data.success === false) {
          Notificaciones.showToastr('Repuestos', response.data.message || 'Los repuestos no pudieron guardarse.', 'error');

          return;
        }

        this.id_detalles_eliminados = [];

        $('#modalRepuestos').modal('toggle');

        // Recalcula y emite el total para el componente padre
        this.calcularTotal(true);
      }).catch(error => {
        // El modal se mantiene abierto para que el usuario pueda corregir y reintentar
        Notificaciones.showToastr('Repuestos', this.obtenerMensajeError(error), 'error');
      });
    },

    /**
     * Traduce la respuesta de error del backend a un mensaje para el usuario.
     * Cubre el 403 del control de acceso y el 422 de validación o de fallo al guardar.
     *
     * @param {Object} error
     *
     * @returns {String}
     */
    obtenerMensajeError(error) {
      const datos = error.response ? error.response.data : null;

      if (!datos) {
        return 'Ocurrió un error al guardar los repuestos.';
      }

      if (datos.errors) {
        const errores = Object.keys(datos.errors).map(campo => datos.errors[campo][0]);

        if (errores.length > 0) {
          return errores.join(' ');
        }
      }

      return datos.error || datos.message || 'Ocurrió un error al guardar los repuestos.';
    },

    obtenerDetalles() {
      axios.get(`api/agendamiento/repuestos/${this.moto.id}/${this.servicio.id}`).then(response => {
        this.detalles = [...response.data]

        if (this.detalles.length === 0) {
          this.agregarDetalle();
        } else {
          this.inicializarComboRepuesto();
        }
      });
    },

    calcularTotalDetalle(index) {
      const precioUnitario = this.detalles[index].precio_unitario;
      const cantidad = this.detalles[index].cantidad;

      if (precioUnitario && cantidad) {
        let total = Math.round(Number(precioUnitario.replace(/\D/g, '')) * cantidad);

        total = new Intl.NumberFormat("es-ES", {
          maximumFractionDigits: 0,
        }).format(total);

        this.detalles[index].total = total;

        this.calcularTotal();
      }
    },

    calcularTotal(emitirTotal) {
      let total = 0;
      this.detalles.forEach(detalle => {
        // Las filas sin repuesto llegan con el total en null
        total += Number(String(detalle.total || 0).replace(/\D/g, ''));
      })

      if (emitirTotal) {
        Bus.$emit("total-repuestos", {total_repuestos: total, moto_id: this.moto.id});
      }
    },

    inicializarComboRepuesto(index = null) {
      this.$nextTick(() => {
        if (index) {
          this.initRepuestosSelect2(`#cmbRepuestos-${index}`);

          return;
        }

        this.initRepuestosSelect2('.js-repuestos');
      })
    },

    initRepuestosSelect2(selector) {
      $(selector).select2({
        placeholder: 'Buscar...',
        ajax: {
          url: '/api/agendamiento/repuestos',
          dataType: 'json',
          delay: 250,
          cache: true,
          minimumInputLength: 3,
          data: function (params) {
            return {
              search: params.term,
              page: params.page || 1
            }
          },
          processResults: (data) => {
            const idRepuestos = this.detalles.map(detalle => detalle.ag_repuesto_id);

            data.results = data.results.map(r => {
              if (idRepuestos.includes(r.id)) {
                r.selected = true;
              }

              return r;
            });

            return data;
          }
        },
        templateSelection: function (data, container) {
          $(data.element).attr('data-precio-unitario', data.precio_unitario);

          return data.text;
        },
      });

      $(selector).change((e) => {
        const $cmb = $(e.currentTarget);
        const $selectedOption = $cmb.find(':selected');
        let precioUnitario = $selectedOption.data('precio-unitario');

        precioUnitario = new Intl.NumberFormat("es-ES", {
          maximumFractionDigits: 0,
        }).format(precioUnitario);

        const index = $cmb.attr('id').split('-').pop();

        this.detalles[index].ag_repuesto_id = $cmb.val();
        this.detalles[index].precio_unitario = precioUnitario;

        this.calcularTotalDetalle(index);
      });
    },

    reInitRepuestosSelect2() {
      document.querySelectorAll('.js-repuestos').forEach(element => {
        $(element).select2('destroy');
      });

      this.initRepuestosSelect2('.js-repuestos');
    }
  },

  mounted() {
    Bus.$on("mostrar-repuestos", moto => {
      this.repuestos = [];
      this.detalles = [];
      // Se reinicia junto al resto: si no, arrastra los ids borrados de la moto anterior
      this.id_detalles_eliminados = [];
      this.moto = moto;

      this.obtenerDetalles();

      const $modal = $('#modalRepuestos');
      $modal.modal({
        backdrop: 'static',
        keyboard: false
      }).toggle();
    });
  },
}
</script>



// WEBPACK FOOTER //
// resources/vue/components/agendamiento/RepuestosMotoServicio.vue